import { Button, TableItem, TableMessage } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { useNewWindowNavigate } from 'hooks/useNewWindowNavigate';
import { t } from 'i18next';
import { PiNavigationArrow, PiPlus, PiTrash } from 'react-icons/pi';
import { useGetArtistLightList } from 'services/artists/light';
import { IClientAccountForm } from 'services/client-account/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const ClientAccountArtists = () => {
  const artistsLightList = useGetArtistLightList();

  const { values, setFieldValue, status, initialStatus } =
    useFormikContext<IClientAccountForm>();

  const navigateToNewWindow = useNewWindowNavigate();

  const artistOptions = (artists: string[]) =>
    artistsLightList.data
      ?.filter(artist => !artists.includes(artist.id))
      .map(artist => ({
        label: artist.nickname,
        value: artist.id,
      })) ?? [];

  const goToArtist = (id: string) => {
    navigateToNewWindow(`artist/${id}`);
  };

  return (
    <Table
      displayMode
      data={{
        nodes:
          values.artists?.map((artist, key) => ({
            id: key,
            value: artist.id,
            label: artist.name,
          })) ?? [],
      }}
      columns={[
        {
          label: t('input.label.artist'),
          renderCell: ({ label, value, id }) => (
            <TableItem>
              {status?.displayMode ? (
                <TableItem.Text text={label} />
              ) : (
                <FormInput.Select
                  name={`artists[${id}].id`}
                  label={t('input.label.artist')}
                  options={artistOptions(
                    values.artists?.map(artist => artist.id)
                  )}
                  onChange={option => {
                    setFieldValue(`artists[${id}].id`, option.value);
                    setFieldValue(`artists[${id}].name`, option.label);
                  }}
                  value={{ label: label ?? '-', value: value }}
                />
              )}
            </TableItem>
          ),
        },

        {
          label: '',
          renderCell: ({ value }) => (
            <TableItem justifyPosition='end'>
              {status?.displayMode ? (
                <Button isClear onlyIcon onClick={() => goToArtist(value)}>
                  <Button.Icon
                    icon={<PiNavigationArrow transform='scale(-1,1)' />}
                  />
                </Button>
              ) : (
                <Button
                  variant={BUTTON_VARIANT.remove}
                  isClear
                  onlyIcon
                  onClick={() =>
                    setFieldValue(
                      `artists`,
                      values.artists?.filter(artist => artist.id !== value)
                    )
                  }>
                  <Button.Icon icon={<PiTrash />} />
                </Button>
              )}
            </TableItem>
          ),
        },
      ]}
      tableOptions={
        status?.displayMode
          ? undefined
          : {
              renderAfterTable: () => (
                <tfoot className='full-width-footer'>
                  <TableMessage
                    className='cursor-pointer'
                    disable={
                      values.artists?.length
                        ? !values.artists[values.artists.length - 1]?.id.length
                        : false
                    }
                    onClick={() =>
                      setFieldValue(`artists[${values.artists?.length ?? 0}]`, {
                        id: '',
                        name: '',
                      })
                    }>
                    <TableItem.Text text={t('button.add')} />
                    <PiPlus />
                  </TableMessage>
                </tfoot>
              ),
            }
      }
      size='compact'
    />
  );
};

export default ClientAccountArtists;
